<template>
	<div @click="goBack">
		<swiper :options="swiperOption" ref="mySwiper">
			<swiper-slide v-for="i,index in img" :key='index'>
				<img class="thatImg" :src="i" />
			</swiper-slide>
			<div class="swiper-pagination" slot="pagination"></div>
			<div class="swiper-scrollbar" slot="scrollbar"></div>
		</swiper>
	</div>
</template>
<script type="text/ecmascript-6">
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
	export default {
		components: {
			swiper,
			swiperSlide
		},
		data() {
			return {
				img: [
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
					'http://img.zcool.cn/community/0142135541fe180000019ae9b8cf86.jpg@1280w_1l_2o_100sh.png',
				],
				swiperOption: {
					notNextTick: true,
					direction: 'horizontal',
					grabCursor: true,
					setWrapperSize: true,
					autoHeight: true,
					paginationType : 'fraction',
					pagination: '.swiper-pagination',
					mousewheelControl: true,
					observeParents: true
				}
			}
		},
		created() {

		},
		methods: {
			goBack() {

			},
			
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@import "./src/assets/scss/common/_mixin";
	
	.swiper-slide {
		float: left;
	}
	
	.thatImg {
		width: 100%;
		height: 21rem;
		margin-top: 5.4rem;
	}
	
	.swiper-container {
		overflow: hidden;
		background: #333;
	}
	
	.swiper-container-horizontal>.swiper-pagination-bullets, 
	.swiper-pagination-custom, .swiper-pagination-fraction{
		bottom: 10px;
	    left: 0;
	    width: 100%;
	}

	.swiper-container {
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		.swiper-pagination {
			position: absolute;
		    text-align: center;
		    -webkit-transition: .3s opacity;
		    -o-transition: .3s opacity;
		    transition: .3s opacity;
		    -webkit-transform: translate3d(0,0,0);
		    transform: translate3d(0,0,0);
		    z-index: 10;
		}
	}
	
	/*点样式*/
	.swiper-container .swiper-pagination{
		margin: 0 auto;
	}
	.swiper-pagination span {
		display: inline-block;
		width: 0.45rem;
		height: 0.45rem;
		background: #6e6f71;
		border-radius: 50%;
		margin: 0 0.1rem;
	}
	
	.swiper-pagination span.swiper-pagination-bullet-active {
		background: #f6f9fe;
	}
	
</style>